import React from 'react';
import { Box, Stepper, Step, StepLabel } from '@mui/material';

interface BrodcastFormProgressProps {
  steps: string[];
  activeStep: number;
}

export default function BrodcastFormProgress({ steps, activeStep }: BrodcastFormProgressProps) {
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
